import contractPage from '../../hoc/contractPage/contractPage';
import getBankPageContent from '../../screens/Une/getContent';
import Une from '../../screens/Une/Une';

export async function getStaticProps() {
  const bank = await getBankPageContent({ cache: false });

  return {
    props: {
      bank,
      seo: bank.seo,
    },
  };
}

export default contractPage(Une, { routeKey: 'UNE' });
